module.exports = __webpack_public_path__ + "2584e2545c33c6630b3fb2d28f439f0e.png";